import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private jwtHelperService: JwtHelperService
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = this.jwtHelperService.tokenGetter();
    if (token && !this.jwtHelperService.isTokenExpired()) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }

  }
}
